import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PlanningHighlightService {
    hoveredPlanningId: number | null = null;
    hoveredRepetitionId: number | null = null;
    savedPlanning$ = new Subject<number>();

    setHovered(planningId: number | null, repetitionId: number | null = null): void {
        this.hoveredPlanningId = planningId;
        this.hoveredRepetitionId = repetitionId;
    }

    triggerSavedPlanning(planningId: number): void {
        this.savedPlanning$.next(planningId);
    }
}
